module.exports = __webpack_public_path__ + "img/waracademy64_ua.fd7886f1.webp";